import { useParams, useSearchParams } from "react-router-dom";
import { displayNameInRightFormat } from "../../../../utils/helpers";
import { useFetchUserDetails } from "../../../../hooks/queries/user";
import JitsiComponent from "../JitsiComponent/JitsiComponent";
import { useFetchJitsiToken } from "../../hooks/meeting.queries";
import ListState from "../../../../components/ListState/ListState";

export default function MeetingRoom() {
    const { sessionHistoryId } = useParams();
    const [searchParams] = useSearchParams();

    const clientName = searchParams.get("with")?.split("_").join(" ");

    const loggedInUser = useFetchUserDetails();

    const { isLoading, error, isSuccess, data } = useFetchJitsiToken(
        sessionHistoryId || ""
    );

    return (
        <div className="h-dvh bg-[#fbfbfb] overflow-y-hidden flex flex-col">
            <div className="h-[8dvh] flex items-center px-24 text-lg">
                Session with
                <span className="capitalize inline-block ml-4 font-semibold">
                    {clientName}
                </span>
            </div>
            <div className="flex-1">
                {isLoading ? (
                    <div
                        className="flex items-center justify-center h-[92vh]"
                        data-testid="loader"
                    >
                        <span className="mid-loader" />
                    </div>
                ) : null}

                {error ? (
                    <div className="h-full text-sm font-medium flex items-center justify-center">
                        <ListState
                            isError
                            errorMsg={
                                error?.response?.data?.message ||
                                "Could not load meeting at this time"
                            }
                            stateHelperText="Plese contact support for assistance"
                            context="general"
                            cardClass="h-[92vh]"
                        />
                    </div>
                ) : null}
                {isSuccess ? (
                    <JitsiComponent
                        providerEmail={loggedInUser?.data?.user_email || ""}
                        providerName={displayNameInRightFormat({
                            firstName: loggedInUser?.data?.first_name || "",
                            lastName: loggedInUser?.data?.last_name || "",
                        })}
                        roomName={sessionHistoryId || ""}
                        token={data.data.token}
                        userId={loggedInUser?.data?.user_id || ""}
                    />
                ) : null}
            </div>
        </div>
    );
}
